export const userListToOptionsMapper = (userList) =>
  userList?.map((userItem) => ({
    label: formatUserName(userItem),
    value: userItem?.user?.id
  }));

export const userListToOptionsMapperForMultiSelect = (userList) =>
  userList?.map((userItem) => ({
    title: formatUserName(userItem),
    value: userItem?.user?.id
  }));

export const investigatorListMapper = (investigators, type) => {
  let userData = [];
  investigators.map((investigator, index) => {
    let caseTotal = 0;
    let caseObj = {};
    investigator['counts']['cases'].map((caseData) => {
      if (type === 'dashboard') {
        if (caseData['status'] !== 'UNASSIGNED') {
          // there should not be unassigned cases in this data, but due to some
          // backend bugs such inconsistency may happen, so this if is temporary fix
          caseTotal += caseData['count'];
          caseObj[caseData['status']] = caseData['count'];
        }
      } else {
        caseTotal += caseData['count'];
      }
    });

    if (type === 'dashboard') {
      userData[index] = {
        ...caseObj,
        name: formatUserName(investigator),
        id: investigator['user']['id'],
        total: caseTotal
      };
    } else {
      userData[index] = {
        name: formatUserName(investigator),
        id: investigator['user']['id'],
        cases: caseTotal,
        alerts: investigator['counts']['alerts'],
        total: caseTotal + investigator['counts']['alerts']
      };
    }
  });

  return userData;
};

export const formatUserName = (userInfo) => {
  const firstName = userInfo?.user?.firstName;
  const lastName = userInfo?.user?.lastName;

  if (userInfo?.user?.username && !userInfo?.user?.isActive) {
    return `${userInfo?.user?.username} (Deactivated)`;
  }

  if (firstName) {
    return `${firstName}${' ' + lastName || ''} (${userInfo?.user?.username})`;
  }

  return userInfo?.user?.username;
};
